const stats = [
  { num: "1.2万+", label: "今日新增趣事" },
  { num: "36万+", label: "累计校园爆料" },
  { num: "4.8万", label: "匿名投稿作者" },
  { num: "5亿+", label: "全站累计笑声" },
];

const floats = [
  { e: "🛏️", cls: "top-[16%] left-[6%]", size: "text-4xl md:text-5xl", rot: "-rotate-12" },
  { e: "📖", cls: "top-[22%] right-[8%]", size: "text-4xl md:text-6xl", rot: "rotate-12" },
  { e: "😅", cls: "bottom-[26%] left-[12%]", size: "text-3xl md:text-5xl", rot: "rotate-6" },
  { e: "📱", cls: "bottom-[30%] right-[14%]", size: "text-3xl md:text-5xl", rot: "-rotate-6" },
];

export default function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-gradient-to-b from-accent-50 via-background-50 to-background-100"
    >
      {/* texture */}
      <div className="dot-grid pointer-events-none absolute inset-0 opacity-60" />
      {/* blobs */}
      <div className="pointer-events-none absolute -top-20 right-0 h-72 w-72 rounded-full bg-primary-200/50 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 left-0 h-80 w-80 rounded-full bg-secondary-100/70 blur-3xl" />

      {floats.map((f) => (
        <span
          key={f.e}
          aria-hidden="true"
          className={`pointer-events-none absolute hidden select-none md:block ${f.cls} ${f.size} ${f.rot}`}
        >
          {f.e}
        </span>
      ))}

      <div className="relative mx-auto flex min-h-[560px] w-full max-w-7xl flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50/80 px-4 py-1.5 text-xs font-bold tracking-wide text-primary-800">
          <i className="ri-fire-fill text-primary-500" /> 校园吃瓜 · 每日更新 · 边看边笑
        </span>

        <h1 className="mt-7 font-heading text-4xl leading-tight text-foreground-900 md:text-6xl">
          宿舍的迷惑行为，
          <br className="md:hidden" />
          比你的期末考试还精彩
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          这里汇集宿舍生活搞笑爆料、课堂同学社死现场、校园同桌奇葩事与班级群聊翻车合集，
          课间八卦聚集地，专收集校园宿舍迷惑行为，包你笑到停不下来。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#featured"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-base font-bold text-white transition-colors hover:bg-primary-600"
          >
            逛逛今日爆点 <i className="ri-arrow-down-line" />
          </a>
          <a
            href="#submit"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-foreground-300 bg-background-50/70 px-7 py-3.5 text-base font-bold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            <i className="ri-edit-2-line" /> 爆料我的故事
          </a>
        </div>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-background-200 bg-background-50/80 px-4 py-4 text-center"
            >
              <dd className="font-heading text-2xl text-primary-700">{s.num}</dd>
              <dt className="mt-1 text-xs text-foreground-500">{s.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}